export default "__VITE_ASSET__8a32a908__"